export default "__VITE_ASSET__D$KARP67__"